import React from 'react';
import { Button } from './ui/button';
import { Coins } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { useCurrency } from '../context/CurrencyContext';

// Choix de la devise d'AFFICHAGE. Le paiement est toujours débité dans la devise
// du guide (il reçoit exactement son tarif).
export const CurrencySwitcher = () => {
  const { currency, setCurrency } = useCurrency();

  const options = [
    { code: 'JPY', name: 'Yen', symbol: '¥' },
    { code: 'EUR', name: 'Euro', symbol: '€' },
    { code: 'USD', name: 'Dollar', symbol: '$' }
  ];

  const current = options.find(o => o.code === currency) || options[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2 text-zinc-300 hover:text-white">
          <Coins className="h-4 w-4" />
          <span className="hidden md:inline">{current.symbol} {current.code}</span>
          <span className="md:hidden">{current.symbol}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-zinc-900 border-zinc-800">
        {options.map((o) => (
          <DropdownMenuItem
            key={o.code}
            onClick={() => setCurrency(o.code)}
            className="text-zinc-300 hover:text-white hover:bg-zinc-800 cursor-pointer"
          >
            {o.symbol} {o.name} ({o.code})
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
